import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ProgressBar from "react-bootstrap/ProgressBar";

import { CollectionTypes } from "../../../../../models/types";
import styles from "./Progress.module.scss";
import trackImg from "../../../../../assets/images/truck.png";

const Progress = ({
  currentPosition,
  deliveryStartPosition,
  windowStartTime,
  windowEndTime,
}) => {
  return (
    <div className={styles.container}>
      <img
        style={{ left: `${currentPosition}%` }}
        className={styles.track_img}
        src={trackImg}
        alt=""
      />
      <ProgressBar className={styles.root}>
        <ProgressBar className={styles.bar1} now={currentPosition} key={1} />
        <ProgressBar
          className={styles.bar2}
          now={deliveryStartPosition - currentPosition}
          key={2}
        />
        <ProgressBar
          className={styles.bar3}
          now={100 - deliveryStartPosition}
          key={3}
        />
      </ProgressBar>
      <span
        style={{ left: `${deliveryStartPosition}%` }}
        className={classNames(
          styles.time,
          styles.time_start,
          deliveryStartPosition > 90 && styles.time_start_shift
        )}
      >
        {windowStartTime}
      </span>
      <span className={classNames(styles.time, styles.time_end)}>
        {windowEndTime}
      </span>
    </div>
  );
};

Progress.propTypes = {
  collection: PropTypes.shape(CollectionTypes.Collection),
  currentPosition: PropTypes.number.isRequired,
  deliveryStartPosition: PropTypes.number.isRequired,
  windowStartTime: PropTypes.string.isRequired,
  windowEndTime: PropTypes.string.isRequired,
};

export default Progress;
